import { Resource as n } from "@coveo/platform-client";
import { Catalog as i } from "./Catalog.js";
import { CatalogSearch as m } from "./CatalogSearch.js";
import { FacetCollectionConfigurations as r } from "./FacetCollectionConfigurations.js";
import { FacetFieldConfigurations as c } from "./FacetFieldConfigurations.js";
import { FacetPerformanceReportingMetrics as e } from "./FacetPerformanceReportingMetrics.js";
import { FeatureStackConfiguration as f } from "./FeatureStackConfiguration.js";
import { ListingPage as u } from "./ListingPage.js";
import { ListingRulePreview as g } from "./ListingRulePreview.js";
import { ListingRules as w } from "./ListingRules.js";
import { ProductListingConfiguration as h } from "./ProductListingConfiguration.js";
import { ProductListingReportingMetrics as a } from "./ProductListingReportingMetrics.js";
import { RecommendationSlotPreview as C } from "./RecommendationSlotPreview.js";
import { RecommendationsMetrics as R } from "./RecommendationsMetrics.js";
import { RuleDefinition as d } from "./RuleDefinition.js";
import { RulePreview as P } from "./RulePreview.js";
import { Rules as l } from "./Rules.js";
import { SearchMetrics as S } from "./SearchMetrics.js";
import { SlotConfiguration as L } from "./SlotConfiguration.js";
import { SynonymRulePreview as y } from "./SynonymRulePreview.js";
import { Synonyms as F } from "./Synonyms.js";
import { TrackingIdLocales as M } from "./TrackingIdLocales.js";
import { Setup as k } from "./Setup.js";
import { Audiences as x } from "./Audiences.js";
import { RuleCount as D } from "./RuleCount.js";
import { CatalogFields as I } from "./CatalogFields.js";
class ot extends n {
  constructor(t, o) {
    super(t, o), this.api = t, this.serverlessApi = o, this.audiences = new x(t, o), this.productListingReportingMetrics = new a(t, o), this.productListingConfigurationsV2 = new h(t, o), this.searchMetrics = new S(t, o), this.listingRules = new w(t, o), this.trackingIdLocales = new M(t, o), this.slotConfiguration = new L(t, o), this.recommendationMetrics = new R(t, o), this.recommendationSlotPreview = new C(t, o), this.rules = new l(t, o), this.synonymRulePreview = new y(t, o), this.listingRulePreview = new g(t, o), this.synonyms = new F(t, o), this.catalogSearch = new m(t, o), this.catalog = new i(t, o), this.catalogFields = new I(t, o), this.facetCollectionConfigurations = new r(t, o), this.facetPerformanceReportingMetrics = new e(t, o), this.facetFieldConfigurations = new c(t, o), this.ruleDefinition = new d(t, o), this.rulePreview = new P(t, o), this.setup = new k(t, o), this.listingPage = new u(t, o), this.ruleCount = new D(t, o), this.featureStackConfiguration = new f(t, o);
  }
}
export {
  ot as CommerceResource
};
//# sourceMappingURL=Commerce.js.map
